interface IDropDownOptions {
    [key: string]: (string )[];
}

const DropDownOptions: IDropDownOptions = {
    borderStyles: [
        'dotted',
        'dashed',
        'solid',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'none',
        'hidden',
    ],
    default: [
        'Options Not Yet Assigned',
    ],
    fonts: [
        'inherit',
        'Druid Regular',
        'Arial',
        'Times New Roman',
        'Helvetica',
        'Times',
        'Courier New',
        'Verdana',
        'Courier',
        'Arial Narrow',
        'Candara',
        'Geneva',
        'Calibri',
        'Optima',
        'Cambria',
        'Garamond',
        'Perpetua',
        'Monaco',
        'Didot',
        'Brush Script MT',
        'Lucida Bright',
        'Copperplate',
    ],
    suggestedActionLayout: [
        'flow',
        'carousel',
        'stacked',
    ],
    timestampFormat: [
        'relative',
        'absolute',
    ],
    wordBreak: [
        'normal',
        'break-all',
        'break-word',
        'keep-all',
    ],
    bubbleNubOffset: ['bottom', 'top'],
    position:
    ['left', 'right'],
    scrollToEndButtonBehavior: ["off", 'any', 'unread']
};

export default DropDownOptions;